import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  ResponsiveIconComponent,
  SvgIcon,
} from "./../../../responsive-icon/responsive-icon.component";
import { RouterModule } from "@angular/router";
import { ButtonDirective } from "@components";

@Component({
  selector: "app-notification-content",
  standalone: true,
  imports: [ResponsiveIconComponent, RouterModule, ButtonDirective],
  templateUrl: "./notification-content.component.html",
  styleUrl: "./notification-content.component.scss",
})
export class NotificationContentComponent {
  @Output() buttonClicked = new EventEmitter<void>();

  @Input() icon!: SvgIcon;
  @Input() text = "";
  @Input() buttonText = "";

  handleButtonClicked(event: Event): void {
    this.buttonClicked.emit();
    event.preventDefault();
    event.stopPropagation();
  }
}
